import { Link } from "wouter";
import { cn } from "@/lib/utils";

interface LegalFooterLinksProps {
  className?: string;
  onLinkClick?: () => void;
}

export default function LegalFooterLinks({
  className,
  onLinkClick,
}: LegalFooterLinksProps) {
  return (
    <div
      className={cn(
        "flex flex-wrap gap-x-3 gap-y-1 text-xs text-muted-foreground",
        className
      )}
    >
      <Link
        href="/terms"
        className="hover:text-foreground transition-colors"
        onClick={onLinkClick}
      >
        Terms of Service
      </Link>
      <Link
        href="/privacy"
        className="hover:text-foreground transition-colors"
        onClick={onLinkClick}
      >
        Privacy Policy
      </Link>
      <Link
        href="/data-deletion"
        className="hover:text-foreground transition-colors"
        onClick={onLinkClick}
      >
        Data Deletion
      </Link>
    </div>
  );
}
